<template>
  <div>
    <Head title="Busqueda" />
    <!-- Start header with image -->
    <div class="container px-0">
      <div class="lpg-header-search position-relative">
        <div class="d-none d-sm-block amp-ad" v-html="amp_ad"></div>
        <h2 class="mt-5 mb-3 lpg-form-title text-center">Buscar</h2>
        <div class="lpg-form px-3">
          <form>
            <div class="row">
              <div class="col-12 col-lg-8 offset-lg-2">
                <div class="mb-4">
                  <text-input id="search" v-model="form.search" :required="true"></text-input>
                </div>
                <div class="col">
                  <button
                    type="submit"
                    @click.prevent="search"
                    class="btn btn-primary mx-auto d-block mb-5"
                  >
                    Buscar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <p class="text-center">NUEVAS OPORTUNIDADES ESPERAN POR TI</p>
      </div>
    </div>
    <!-- End header with image -->

    <!-- Start form -->
    <div class="container pt-2 pt-lg-4">
      <div class="lpg-form px-3">
        <h2 class="mt-5 mb-3 lpg-form-title text-center" v-if="categorydata">
          {{ categorydata.name }}
        </h2>
        <p class="text-center">Resultados de busqueda {{ searchinput }}</p>
        <div class="lpg-content-list">
          <div class="row" v-if="resultados.length">
            <div class="col-12 col-md-6" v-for="(resultado, key) in resultados" :key="key">
              <Link :href="$route('jobposting', { id: resultado.id })" class="lpg-media-link">
                <div class="lpg-media-list d-flex align-items-center">
                  <img src="\images\bolsa-img.png" class="img-fluid" alt="..." />
                  <div class="lpg-media-body">
                    <h4 class="lpg-media-title">{{ resultado.title }}</h4>
                    <p class="lpg-media-desc">{{ resultado.short_description }}</p>
                  </div>
                </div>
              </Link>
            </div>
          </div>
          <div class="row" v-else>
            <h2 class="mt-5 mb-3 lpg-form-title text-center">
              No se encontraron resultados de la busqueda
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div class="d-block d-sm-none " v-html="amp_sticky"></div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout'
import TextInput from '@/Components/Form/TextInput.vue'
import Icon from '@/Components/BS-Icon'

export default {
  layout: Layout,
  components: { Link, Head, TextInput, Icon },

  methods: {
    search() {
      this.$inertia.get(this.$route('busqueda.show'), this.form)
    },
  },
  props: {
    resultados: Array,
    searchinput: String,
    typesearch: String,
    category: String,
    categorydata: Object,
  },
  data() {
    return {
      form: {
        search: this.searchinput,
      },
      amp_ad:
        '<amp-ad width=728 height=90 type="doubleclick" data-slot="/4483046/lpg-dsk-empleo" data-multi-size="728x90" data-multi-size-validation="false" data-loading-strategy="3" data-enable-refresh="30"></amp-ad>',
      amp_sticky:
        '<amp-sticky-ad layout="nodisplay" class="amp-sticky-ad"><amp-ad width="320"height="100" type="doubleclick" data-slot="/4483046/lpg-mov-empleo" data-multi-size="320x100" data-multi-size-validation="false" data-loading-strategy="3" data-enable-refresh="30"></amp-ad></amp-sticky-ad>',
    }
  },
}
</script>

<style scoped>
.amp-ad {
  position: relative;
  padding: 25px 0 5px 0;
  text-align: center;
}
</style>
